import lulliLogo from "@assets/images/lulli-logo.svg";
import { useCloud } from "@dashboard/auth/hooks/useCloud";
import { Box, Text, Tooltip } from "@saleor/macaw-ui-next";
import { CloudIcon } from "lucide-react";
import { type ReactElement, type ReactNode, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import { useEnvLink } from "./menu/hooks/useEnvLink";
import classes from "./Sidebar.module.css";

interface MountingPointProps {
  action?: ReactNode;
}

export const MountingPoint = ({ action }: MountingPointProps): ReactElement => {
  const { isAuthenticatedViaCloud } = useCloud();
  const envLink = useEnvLink();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      display="flex"
      gap={3}
      paddingX={4}
      paddingY={5}
      alignItems="center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box __flex="1">
        <SVG src={lulliLogo} className={classes.logo} role="img" aria-label="Lulli" />
      </Box>
      {isAuthenticatedViaCloud && (
        <>
          <Tooltip>
            <Tooltip.Trigger>
              <Box
                as="a"
                href={envLink}
                target="_blank"
                rel="noopener noreferrer"
                display="flex"
                alignItems="center"
                color="default2"
                paddingRight={1}
                style={{
                  opacity: isHovered ? 1 : 0,
                  transition: "opacity 0.15s ease-in-out",
                }}
                data-test-id="cloud-environment-link"
              >
                <CloudIcon size={16} />
              </Box>
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom">
              <Tooltip.Arrow />
              <Text size={2}>
                <FormattedMessage defaultMessage="Go to Saleor Cloud" id="EXqb2l" />
              </Text>
            </Tooltip.Content>
          </Tooltip>
        </>
      )}
      {action}
    </Box>
  );
};
